import {Button, Group, Modal, Stack, Text} from '@mantine/core'

type ConfirmDialogProps = {
    opened: boolean
    title: string
    message: string
    confirmLabel?: string
    cancelLabel?: string
    color?: string
    loading?: boolean
    onConfirm: () => void
    onCancel: () => void
}

export function ConfirmDialog({
    opened,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    color = 'red',
    loading = false,
    onConfirm,
    onCancel,
}: ConfirmDialogProps) {
    return (
        <Modal opened={opened} onClose={onCancel} title={title} centered>
            <Stack gap="md">
                <Text>{message}</Text>
                <Group justify="flex-end">
                    <Button variant="subtle" onClick={onCancel} disabled={loading}>
                        {cancelLabel}
                    </Button>
                    <Button color={color} loading={loading} onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}
